module.exports = "<script src=\"./summernote-fr-FR.js\"></script>\n<textarea id=\"summernote\"></textarea>"


//////////////////
// WEBPACK FOOTER
// /builds/eveasoft/lea/lea-front/src/app/shared/summernote/summernote.component.html
// module id = ../../../../../src/app/shared/summernote/summernote.component.html
// module chunks = main